export class PropertyItemBulkActionEnum {
    
	static AddFee: number = 10; 
	static MarkOutOfStorage: number = 20; 
	static Delete: number = 30; 
	static ChangeSidemark: number = 40; 
	static ChangeDestinationRoom: number = 50; 


	static getChoices(): any[] {
		return [
		{
			Value: PropertyItemBulkActionEnum.AddFee, Text: 'Add Fee'
	},{
			Value: PropertyItemBulkActionEnum.MarkOutOfStorage, Text: 'Mark Out Of Storage'
	},{
			Value: PropertyItemBulkActionEnum.Delete, Text: 'Delete'
	},{
			Value: PropertyItemBulkActionEnum.ChangeSidemark, Text: 'Change Sidemark'
	},{
			Value: PropertyItemBulkActionEnum.ChangeDestinationRoom, Text: 'Change Destination Room'
	}
			
		];
	}

}
